<template>
  <div class="info-section">
    <div class="info-section__header" v-if="$slots.header">
      <slot name="header"></slot>
      <hr>
    </div>
    <div class="info-section__content">
      <slot name="default">
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoSection'
}
</script>

<style lang="stylus">
  @import "./styles.styl"
</style>
